// extracted by mini-css-extract-plugin
export default {"box":"index_box_2-RuX","slider":"index_slider_JSVx8","container":"index_container_TYgeJ"};